import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeExeId } from "../../../reducers/session";
/**
 * Hook to track the running state of tools.
 * Returns whether any exclusive tool is running and a function to check specific tools.
 */
export const useToolsRunning = () => {
    const toolsRunning = useSelector((state) => state.session.base.toolsRunning);
    const exclusiveRunning = useMemo(() => {
        return Object.keys(toolsRunning).some((exeId) => toolsRunning[exeId].exclusive);
    }, [toolsRunning]);
    const isToolRunning = useMemo(() => {
        return (toolExePath) => {
            if (!toolExePath)
                return false;
            const exeId = makeExeId(toolExePath);
            return toolsRunning[exeId] !== undefined;
        };
    }, [toolsRunning]);
    return { exclusiveRunning, isToolRunning };
};
